'use strict';

const axios = require('axios');
import { listenDOMEvent } from '@jspartials/dom-api-utils';
import {
  classes,
  addClassToElement,
  removeClassToElement,
  toggleClassToElement
} from '@jspartials/class-list-utils';
import {
  cleanAllErrors,
  handleErrors,
  countErrors,
  togglePasswordVisibility
} from '@jspartials/form-utils';
import {
  gtmLaunchCustomerLoggedSuccessfully,
  gtmLaunchCustomerSignUpSuccessfully
} from '@jspartials/gtm-utils';

import { initResetPassword } from '../password/reset';

const selector = {
  wrapper: '.js-login-and-sign-up-content-wrapper',
  button: {
    revealPassword: '.js-button-reveal-password',
    toggleContent: '.js-button-toggle-content',
    loginWithOtherMail: '.js-button-login-with-other-mail',
    loginGoBack: '.js-button-login-go-back',
    forgotPassword: '.js-button-forgot-password'
  },
  form: {
    login: {
      self: '.js-form-login',
      content: '.js-content-login',
      submit: '.js-form-login-button--submit'
    },
    signup: {
      self: '.js-form-signup',
      content: '.js-content-signup',
      submit: '.js-form-signup-button--submit',
      recaptcha: '.js-form-signup-input--recaptcha'
    },
    inputPassword: '.js-form-input--password',
    fieldPassword: '.js-field--password'
  }
};

// Buttons
var buttonsRevealPassword = null;
var buttonsToggleContent = null;
var buttonLoginWithOtherMail = null;
var buttonsLoginGoBack = null;
var buttonForgotPassword = null;

// Wrapper
var loginAndSignupContentWrapper = null;

// Login
var formLogin = null;
var contentLogin = null;
var formLoginButtonSubmit = null;
// Signup
var contentSignup = null;
var formSignup = null;
var formSignupButtonSubmit = null;
var formSignupInputRecaptcha = null;

// Toggle content between login and signup
const toggleContent = (event) => {
  event.preventDefault();

  toggleClassToElement(contentLogin, classes.hidden);
  toggleClassToElement(contentSignup, classes.hidden);
};
// Handle login form submit
const handleFormLogin = (event) => {
  event.preventDefault();

  const urlFormLogin = formLogin.action;
  const formData = new FormData(formLogin);

  cleanAllErrors();
  addClassToElement(formLoginButtonSubmit, classes.is.loading);

  axios
    .post(urlFormLogin, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(function (response) {
      if (response.status === 200) {
        const responseData = response.data;
        const errors = 'errors' in responseData ? responseData.errors : null;
        const success =
          'success' in responseData ? responseData.success : false;
        const existsExternallyCustomer =
          'existsExternallyCustomer' in responseData
            ? responseData.existsExternallyCustomer
            : false;
        const redirectUrl =
          'redirectUrl' in responseData ? responseData.redirectUrl : null;
        const totalErrors = errors ? countErrors(errors) : 0;
        const hashedEmail =
          'hashedEmail' in responseData ? responseData.hashedEmail : '';

        if (success) {
          gtmLaunchCustomerLoggedSuccessfully({
            hashedEmail: hashedEmail
          });
          if (existsExternallyCustomer && redirectUrl) {
            reloadLoginAndSignup(redirectUrl);
          } else window.location.href = redirectUrl;
        } else if (totalErrors > 0) {
          handleErrors(errors);
          removeClassToElement(formLoginButtonSubmit, classes.is.loading);
        } else {
          removeClassToElement(formLoginButtonSubmit, classes.is.loading);
        }
      } else {
        console.warn('Response status is not 200');
        removeClassToElement(formLoginButtonSubmit, classes.is.loading);
      }
    })
    .catch(function (error) {
      console.error(error);
      removeClassToElement(formLoginButtonSubmit, classes.is.loading);
    })
    .then(function () {
      formLoginButtonSubmit.blur();
    });
};

// Handle signup form submit
const handleFormSignup = (event) => {
  event.preventDefault();

  const urlFormSignup = formSignup.action;
  const formData = new FormData(formSignup);

  cleanAllErrors();
  addClassToElement(formSignupButtonSubmit, classes.is.loading);

  axios
    .post(urlFormSignup, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(function (response) {
      if (response.status === 200) {
        const responseData = response.data;
        const errors = 'errors' in responseData ? responseData.errors : null;
        const success =
          'success' in responseData ? responseData.success : false;
        const totalErrors = errors ? countErrors(errors) : 0;
        const existsCustomer =
          'existsCustomer' in responseData
            ? responseData.existsCustomer
            : false;
        const redirectUrl =
          'redirectUrl' in responseData ? responseData.redirectUrl : null;
        const hashedEmail =
          'hashedEmail' in responseData ? responseData.hashedEmail : '';

        if (success) {
          gtmLaunchCustomerSignUpSuccessfully({
            hashedEmail: hashedEmail
          });
          if (existsCustomer && redirectUrl) {
            reloadLoginAndSignup(redirectUrl);
          } else window.location.href = redirectUrl;
        } else if (totalErrors > 0) {
          handleErrors(errors);
          removeClassToElement(formSignupButtonSubmit, classes.is.loading);
        } else {
          removeClassToElement(formSignupButtonSubmit, classes.is.loading);
        }
      } else {
        console.warn('Response status is not 200');
        removeClassToElement(formSignupButtonSubmit, classes.is.loading);
      }
    })
    .catch(function (error) {
      console.error(error);
      removeClassToElement(formSignupButtonSubmit, classes.is.loading);
    })
    .then(function () {
      formSignupButtonSubmit.blur();
    });
};

export function reloadLoginAndSignup(url) {
  axios
    .get(url)
    .then((response) => {
      loginAndSignupContentWrapper.innerHTML = response.data.htmlText;
      init();
    })
    .catch((error) => {
      console.error(error);
    });
}

// Init
export function init() {
  // Buttons
  buttonsRevealPassword = document.querySelectorAll(
    selector.button.revealPassword
  );
  buttonsToggleContent = document.querySelectorAll(
    selector.button.toggleContent
  );
  buttonLoginWithOtherMail = document.querySelector(
    selector.button.loginWithOtherMail
  );
  buttonsLoginGoBack = document.querySelectorAll(selector.button.loginGoBack);
  buttonForgotPassword = document.querySelector(selector.button.forgotPassword);

  // Wrapper
  loginAndSignupContentWrapper = document.querySelector(selector.wrapper);

  // Login
  formLogin = document.querySelector(selector.form.login.self);
  contentLogin = document.querySelector(selector.form.login.content);
  formLoginButtonSubmit = document.querySelector(selector.form.login.submit);

  // Signup
  contentSignup = document.querySelector(selector.form.signup.content);
  formSignup = document.querySelector(selector.form.signup.self);
  formSignupButtonSubmit = document.querySelector(selector.form.signup.submit);
  formSignupInputRecaptcha = document.querySelector(
    selector.form.signup.recaptcha
  );

  // Toggle content of page
  buttonsToggleContent.forEach((button) => {
    listenDOMEvent(button, 'click', toggleContent);
  });

  // Toggle password visibility
  if (buttonsRevealPassword) {
    buttonsRevealPassword.forEach((button) => {
      listenDOMEvent(button, 'click', function () {
        const fieldPassword = button.closest(selector.form.fieldPassword);
        const inputPassword = fieldPassword.querySelector(
          selector.form.inputPassword
        );
        toggleClassToElement(fieldPassword, classes.show.password);
        togglePasswordVisibility(inputPassword);
      });
    });
  }

  // Submit login form
  listenDOMEvent(formLogin, 'submit', handleFormLogin);

  // Submit signup form
  listenDOMEvent(formSignup, 'submit', handleFormSignup);

  listenDOMEvent(buttonLoginWithOtherMail, 'click', function (e) {
    e.preventDefault();
    reloadLoginAndSignup(buttonLoginWithOtherMail.href);
  });

  buttonsLoginGoBack.forEach((buttonLoginGoBack) => {
    listenDOMEvent(buttonLoginGoBack, 'click', function (e) {
      e.preventDefault();
      reloadLoginAndSignup(buttonLoginGoBack.href);
    });
  });

  listenDOMEvent(buttonForgotPassword, 'click', function (e) {
    e.preventDefault();
    reloadLoginAndSignup(buttonForgotPassword.href);
  });

  // Google ReCaptcha
  if (formSignupInputRecaptcha) {
    const executeRecaptcha = () => {
      grecaptcha.enterprise.ready(async () => {
        const action = formSignupInputRecaptcha.dataset.action;
        const id = formSignupInputRecaptcha.dataset.id;
        const token = await grecaptcha.enterprise.execute(id, { action: action });
        formSignupInputRecaptcha.value = token;
      });
    };

    const id = formSignupInputRecaptcha.dataset.id;
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${id}`;
    script.onload = executeRecaptcha;
    document.head.appendChild(script);
  }
  initResetPassword();
}
